export const getHappyHourStatus = (happyHourState) => {
    const { happyHour, happyHourFrom, happyHourTo, happyHourDiscount } = happyHourState;
  
    if (!happyHour || !happyHourFrom || !happyHourTo) {
      return {
        isHappyHour: false,
        happyDiscount: 0,
        timeRange: null
      };
    }
  
    const parseTime = (timeStr) => {
      const [time, modifier] = timeStr.split(' ');
      let [hour, minute = '0'] = time.split(':');
      hour = parseInt(hour, 10);
      minute = parseInt(minute, 10);
  
      if (modifier === 'PM' && hour !== 12) hour += 12;
      if (modifier === 'AM' && hour === 12) hour = 0;
  
      return { hour, minute };
    };
  
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
  
    const { hour: fromHour, minute: fromMin } = parseTime(happyHourFrom);
    const { hour: toHour, minute: toMin } = parseTime(happyHourTo);
  
    const fromMinutes = fromHour * 60 + fromMin;
    const toMinutes = toHour * 60 + toMin;
  
    let withinRange = false;
  
    if (fromMinutes < toMinutes) {
      // Normal time range
      withinRange = currentMinutes >= fromMinutes && currentMinutes < toMinutes;
    } else {
      // Crosses midnight
      withinRange = currentMinutes >= fromMinutes || currentMinutes < toMinutes;
    }
  
    const isHappyHour = happyHour && withinRange;
  
    return {
      isHappyHour,
      happyDiscount: isHappyHour ? happyHourDiscount : 0,
      timeRange: `${happyHourFrom} - ${happyHourTo}`
    };
  };
  